module.exports = __webpack_public_path__ + "img/icon-warning.d3c19093.svg";